import React from 'react'
import { render } from 'react-dom'
import * as Sentry from '@sentry/react'
import TagManager from 'react-gtm-module'
import Root from 'routes'
import store, { history } from 'store'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import '@formatjs/intl-pluralrules/locale-data/es'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/es'

if (typeof window !== 'undefined' && !window.__reactRemoveChildFixApplied) {
  const origRemoveChild = Node.prototype.removeChild
  const origInsertBefore = Node.prototype.insertBefore

  // eslint-disable-next-line func-names
  Node.prototype.removeChild = function (child) {
    try {
      return origRemoveChild.call(this, child)
    } catch (err) {
      if (err.name === 'NotFoundError') {
        return child // ignore missing node
      }
      throw err
    }
  }

  // eslint-disable-next-line func-names
  Node.prototype.insertBefore = function (newNode, refNode) {
    try {
      return origInsertBefore.call(this, newNode, refNode)
    } catch (err) {
      if (err.name === 'NotFoundError') {
        // refNode already gone → just append
        return this.appendChild(newNode)
      }
      throw err
    }
  }

  window.__reactRemoveChildFixApplied = true
}

const env = window._env

if (env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: env.REACT_APP_SENTRY_DSN,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    integrations: [new Sentry.Replay()],
  })
}

if (env.REACT_APP_ENV === 'prod' && env.REACT_APP_GTM_ID) {
  TagManager.initialize({
    gtmId: env.REACT_APP_GTM_ID,
  })
}

render(
  <Root store={store} history={history} />,
  document.getElementById('root'),
)
